import { _enum, boolean, object, schema, string } from "@anna-money/anna-web-lib/serializer";

export enum ANNEX_URL {
  A = "https://www.gov.uk/government/publications/incorporation-and-names/annex-a-sensitive-words-and-expressions-or-words-that-could-imply-a-connection-with-government",
  B = "https://www.gov.uk/government/publications/incorporation-and-names/annex-b-words-and-expressions-that-could-imply-a-connection-with-a-government-department-a-devolved-administration-or-a-local-or-specified-public-authority",
  C = "https://www.gov.uk/government/publications/incorporation-and-names/annex-c-other-regulated-words-and-expressions--2",
  OTHER = "https://www.gov.uk/government/publications/incorporation-and-names/incorporation-and-names",
}

export class SensitiveWord extends schema(
  {
    word: string().optional(),
    annex: _enum(Object.keys(ANNEX_URL) as Array<keyof typeof ANNEX_URL>, "ANNEX_URL_KEYS").optional(),
  },
  "SensitiveWord",
) {}

export class NameAvailabilityData extends schema(
  {
    isAvailable: boolean(),
    isValidName: boolean().optional(true),
    recommendedName: string().optional(),
    isBusinessNameRegistered: boolean().optional(),
    sensitiveWord: object(SensitiveWord).optional(),
  },
  "NameAvailabilityData",
) {}
